var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{'loading':_vm.isLoading}},[_c('header-section'),_c('songs-container'),_c('music-player'),_c('comment-box')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }